import { GameScene } from '@Core/GameScene/GameScene';
import { ESymbolRoles } from '@Core/Reels/SymbolRoles';
import { SymbolSpinePool } from '@Core/SpinePool/SymbolSpinePool';
import { gameInstance } from '@Game/GameComponent';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { EntryCondition } from '@Managers/StateMachine/EntryCondition';
import { LeaveCondition } from '@Managers/StateMachine/LeaveCondition';
import { EGameStates } from '@Managers/StateManager/GameStates';
import { Container } from 'pixi.js';
import { SymbolExpansionStrategy } from './ExpandingSymbolFeature.types';
import { Symbol360ExpansionStrategy } from './SymbolExpansionStrategies/Symbol360ExpansionStrategy';
import { VerticalExpansionStrategy } from './SymbolExpansionStrategies/VerticalExpansionStrategy';

export const EXPANDING_SYMBOL_ROLES: number[] = [
    ESymbolRoles.EXPANDING_WILD_VERTICAL,
    ESymbolRoles.EXPANDING_WILD_HORIZONTAL,
    ESymbolRoles.EXPANDING_WILD_360,
    ESymbolRoles.SPECIAL_SYMBOL
];

export const EXPANDING_SYMBOL_STRATEGY_BY_ROLE_TYPE: Record<
    number,
    (
        scene: GameScene,
        topLayerContainer: Container,
        spinePool: SymbolSpinePool,
        sumbolIds: number[],
        isVisibleAfterExpanding?: boolean
    ) => SymbolExpansionStrategy
> = {
    [ESymbolRoles.EXPANDING_WILD_VERTICAL]: (scene, topLayerContainer, spinePool, symbolIds, isVisibleAfterExpanding) => {
        const symbolConfigurations = symbolIds.map((symbolId) => {
            const config = scene.game.gameStore.get(EGameStoreKeys.SymbolConfiguration).find((symbolConfig) => symbolConfig.id === symbolId);
            return config;
        });
        symbolConfigurations.forEach((config) => {
            const numberOfReels = scene.game.gameStore.get(EGameStoreKeys.NumberOfReels);
            if (config) spinePool.populatePool(config, numberOfReels);
        });
        const strategy = new VerticalExpansionStrategy(scene, topLayerContainer, isVisibleAfterExpanding);
        return strategy;
    },

    //[ESymbolRoles.EXPANDING_WILD_HORIZONTAL]: () => new HorizontalExpansionStrategy(),

    [ESymbolRoles.EXPANDING_WILD_360]: (scene, topLayerContainer, spinePool, symbolIds, isVisibleAfterExpanding) => {
        const symbolConfigurations = symbolIds.map((symbolId) => {
            const config = scene.game.gameStore.get(EGameStoreKeys.SymbolConfiguration).find((symbolConfig) => symbolConfig.id === symbolId);
            return config;
        });
        symbolConfigurations.forEach((config) => {
            const numberOfReels = scene.game.gameStore.get(EGameStoreKeys.NumberOfReels);
            if (config) spinePool.populatePool(config, numberOfReels);
        });
        const strategy = new Symbol360ExpansionStrategy(scene, topLayerContainer, isVisibleAfterExpanding);
        return strategy;
    },

    [ESymbolRoles.SPECIAL_SYMBOL]: (scene, topLayerContainer, spinePool, symbolIds, isVisibleAfterExpanding = false) => {
        const symbolConfigurations = symbolIds.map((symbolId) => {
            const config = scene.game.gameStore.get(EGameStoreKeys.SymbolConfiguration).find((symbolConfig) => symbolConfig.id === symbolId);
            return config;
        });
        symbolConfigurations.forEach((config) => {
            const numberOfReels = scene.game.gameStore.get(EGameStoreKeys.NumberOfReels);
            if (config) spinePool.populatePool(config, numberOfReels);
        });
        const strategy = new VerticalExpansionStrategy(scene, topLayerContainer, isVisibleAfterExpanding);
        return strategy;
    }
};

const entryCondition = new EntryCondition<EGameStates>('checkIfAnyExpandingWildWon', () => {
    const { isWinningExpandingSymbolPresent } = gameInstance.gameStore.get(EGameStoreKeys.ExpandingSymbolState);
    const { isLastWinPresentationStep } = gameInstance.gameStore.get(EGameStoreKeys.BaseWinPresentationState);
    const shouldShowExpandingSymbol = isWinningExpandingSymbolPresent && isLastWinPresentationStep;
    return shouldShowExpandingSymbol;
});
export const expandingSymbolStateLeaveCondition = new LeaveCondition<EGameStates>('waitForExpandingSymbolAnimations');
export const postExpandingSymbolStateLeaveCondition = new LeaveCondition<EGameStates>('waitForSymbolsUnderneathExpandedSymbolToBeSwapped');

export const subStates = {
    [EGameStates.PRE_EXPANDING_SYMBOL_STATE]: {
        entryConditions: [entryCondition],
        leaveConditions: []
    },
    [EGameStates.EXPANDING_SYMBOL_STATE]: {
        entryConditions: [entryCondition],
        leaveConditions: [expandingSymbolStateLeaveCondition]
    },
    [EGameStates.POST_EXPANDING_SYMBOL_STATE]: {
        entryConditions: [entryCondition],
        leaveConditions: [postExpandingSymbolStateLeaveCondition]
    }
};
